import { baseApi } from '@shared/api'
import { CheckDirectorRequest, CheckDirectorResponse } from './types'

const checkDirectorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCheckDirector: builder.mutation<
      CheckDirectorResponse,
      CheckDirectorRequest
    >({
      query: (args) => ({
        url: '/ib/signing/director/check-with-asan',
        data: args,
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
    fetchCheckDirectorWithoutAsan: builder.mutation<
      CheckDirectorResponse,
      CheckDirectorRequest
    >({
      query: (args) => ({
        url: '/ib/signing/director/check-without-asan',
        data: args,
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
  }),
})

export const {
  useFetchCheckDirectorMutation,
  useFetchCheckDirectorWithoutAsanMutation,
} = checkDirectorApi
